<!-- <template>
   <div :class="inlinerows == 'true' ? 'mb-3 row' : 'mb-3'">
     <label v-if="label" for="exampleFormControlInput1" :class="inlinerows == 'true' ? 'col-sm-2 col-form-label' : 'form-label'">{{ label }}</label>
     <div :class="inlinerows == 'true' ? 'col-sm-10' : label ? '' : 'col-md-12'">
    
-->

<template>
  <div :class="inlinerows == 'true' ? inlinerowclasses + ' row' : inlinerowclasses">
    <label v-if="label" for="exampleFormControlInput1" :class="inlinerows == 'true' ? inlineLabelClass + ' col-form-label' : 'form-label'">{{ label }}</label>
    <div :class="inlinerows == 'true' ? inlineInputClass : label ? '' : 'col-md-12'">
     




      <multiselect :required="mandatory ? true : false" deselectLabel="" selectLabel="" v-model="value" :tag-placeholder="tagplaceholder" :placeholder="placeholder" label="name" :track-by="valuefield" :options="data" :multiple="multiple" :taggable="true" @tag="addTag" @input="input" :allow-empty="allowempty" :searchable="searchable"></multiselect>
        <small class="input-error" v-if="error">{{ error }}</small>

        
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import "../../assets/scss/form-group.scss";
import "../../assets/scss/multi-selector.scss";

export default {
  name: "multi-selector",
  mounted() {
    this.value = this.$props.selected ? this.$props.selected : [];
  },
  methods: {
    addTag(newTag) {
      if (this.$props.taggable == false) {
        return;
      }

      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };

      this.options.push(tag);
      this.value.push(tag);
    },
    clearAll() {
      this.value = [];
    },
    input(payload) {
      this.$emit("input", payload);
    },
  },
  data() {
    return {
      value: [],
      options: [],
    };
  },
  created() {},
  props: {



    label: {
      type: String,
      required: true,
    },
    inlinerows: {
      default: false,
    },
    inlinerowclasses: {
      default: "mb-3",
    },
    inlineLabelClass: {
      default: "col-sm-2",
    },
    inlineInputClass: {
      default: "col-sm-10",
    },
    error: {
      type: String,
      default: "",
    },


    // label: {
    //   type: String,
    //   required: true,
    // },
    //     inlinerows: {
    //   // type: Boolean,
    //   default: false,
    // },











    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },

    classes: {
      type: String,
      default: "",
    },
    allowempty: {
      default: false,
    },
    multiple: {
      default: true,
    },
    searchable: {
      default: true,
    },
    selected: {
      default: "",
    },
    placeholder: {
      type: String,
      required: false,
    },
    tagplaceholder: {
      type: String,
      required: false,
    },
    mandatory: {
      // type: Boolean,
      default: false,
    },
    data: {
      // type: Object,
      required: true,
    },
    valuefield: {
      type: String,
      required: true,
      default: "id",
    },

    taggable: {
      default: false,
    },
  },
  components: {
    Multiselect,
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
